<template>
  <div class="has-logo">
    <sidebar-logo :collapse="isCollapse" />
    <div v-if="!isCollapse" class="sidebar-search">
      <el-input
        v-model="searchText"
        placeholder="Tìm menu..."
        prefix-icon="el-icon-search"
        size="small"
        clearable
      ></el-input>
    </div>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in filteredRouters"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SidebarLogo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'
// import { loginInfo } from '@/services/auth'

export default {
  name: 'Sidebar',
  components: {
    SidebarLogo,
    SidebarItem
  },
  data() {
    return {
      searchText: ''
    }
  },
  computed: {
    ...mapState({
      opened: (state) => state.sidebar.opened
    }),
    routers() {
      return this.$router.options.routes.find((r) => r.path === '/').children
    },
    filteredRouters() {
      if (!this.searchText || !this.searchText.trim()) {
        return this.routers
      }
      const keyword = this.searchText.toLowerCase().trim()
      const matchRoute = (r) => {
        const title = (r.meta && r.meta.title) ? r.meta.title.toLowerCase() : ''
        const name = r.name ? r.name.toLowerCase() : ''
        const path = r.path ? r.path.toLowerCase() : ''
        const type = (r.meta && r.meta.data && r.meta.data.type) ? r.meta.data.type.toLowerCase() : ''
        return title.includes(keyword) || name.includes(keyword) || path.includes(keyword) || type.includes(keyword)
      }

      return this.routers.filter((route) => {
        if (matchRoute(route)) {
          return true
        }
        if (route.children && route.children.length > 0) {
          return route.children.some((child) => matchRoute(child))
        }
        return false
      })
    },
    activeMenu() {
      return this.$route.path.split('/').slice(0, 2).join('/')
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.opened
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-search {
  padding: 8px 12px;
  flex-shrink: 0;
  ::v-deep .el-input__inner {
    background-color: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.12);
    color: #fff;
    border-radius: 6px;
    &::placeholder {
      color: rgba(255, 255, 255, 0.4);
    }
    &:focus {
      border-color: rgba(255, 255, 255, 0.3);
      background-color: rgba(255, 255, 255, 0.12);
    }
  }
  ::v-deep .el-input__prefix {
    color: rgba(255, 255, 255, 0.4);
  }
  ::v-deep .el-input__suffix {
    color: rgba(255, 255, 255, 0.4);
  }
}
</style>
